import { Box, Flex, useRadio, useRadioGroup } from '@frontend/components';

const Color = ({ color, ...props }: { color: string }) => {
  const { getInputProps, getRadioProps, state } = useRadio(props);
  const input = getInputProps();
  const radio = getRadioProps();
  return (
    <Box as="label" flex="1">
      <input {...input} />
      <Box
        {...radio}
        cursor="pointer"
        borderStyle="solid"
        borderWidth={state.isChecked ? '2px' : '1px'}
        borderColor={state.isChecked ? 'interaction.main' : 'separator.border'}
        _focus={{
          boxShadow: 'focus',
        }}
        borderRadius="sm"
        h={4}
      >
        <Box
          h="100%"
          borderStyle="solid"
          borderWidth={state.isChecked ? '2px' : '1px'}
          borderColor="page.surface"
          borderRadius="sm"
          bg={color}
        />
      </Box>
    </Box>
  );
};

type ColorInputProps = {
  onChange: (nextValue: string) => void;
  value: string;
  name: string;
  colors: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
};

export const ColorInput = ({
  onChange,
  value,
  name,
  colors,
  ...rest
}: ColorInputProps) => {
  const { getRootProps, getRadioProps } = useRadioGroup({
    name,
    defaultValue: value,
    onChange: onChange,
  });
  const group = getRootProps();

  return (
    <Flex {...group} gap={0.75} {...rest}>
      {colors.map((value) => {
        const radio = getRadioProps({
          value,
        });
        return <Color key={value} color={value} {...radio} />;
      })}
    </Flex>
  );
};
